/**
 * Date-extensions locale Turkish [tr]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('tr', {
    monthNames: ['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran','Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'],
    monthShortNames: ['Oca','Şub','Mar','Nis','May','Haz','Tem','Ağu','Eyl','Eki','Kas','Ara'],
    dayNames: ['Pazar','Pazartesi','Salı','Çarşamba','Perşembe','Cuma','Cumartesi'],
    dayShortNames: ['Paz','Pts','Sal','Çar','Per','Cum','Cts']
});
